const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

// Restore Dawn storefront globals omitted from the customized theme layout.
window.cartStrings = window.cartStrings || {
  error: 'There was an error while updating your cart. Please try again.',
  quantityError: 'You can only add [quantity] of this item to your cart.'
};
window.variantStrings = window.variantStrings || {
  addToCart: 'Add to cart',
  soldOut: 'Sold out',
  unavailable: 'Unavailable',
  unavailable_with_option: '[value] - Unavailable'
};
window.quickOrderListStrings = window.quickOrderListStrings || {
  itemsAdded: '[quantity] items added',
  itemAdded: '[quantity] item added',
  itemsRemoved: '[quantity] items removed',
  itemRemoved: '[quantity] item removed',
  viewCart: 'View cart',
  each: '[money] each'
};
window.accessibilityStrings = window.accessibilityStrings || {
  imageAvailable: 'Image [index] is now available in gallery view',
  shareSuccess: 'Link copied to clipboard',
  pauseSlideshow: 'Pause slideshow',
  playSlideshow: 'Play slideshow',
  recipientFormExpanded: 'Gift card recipient form expanded',
  recipientFormCollapsed: 'Gift card recipient form collapsed'
};
